function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { FETCH_CONTENT_SUCCESS } from "../actions";
import initialState from "./initialState";
// HTML To Text Fix #6044
var CharcodeEntitiesToChar = function() {
    var str = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return str.replace(/&#(\d+);/g, function(match, code) {
        return String.fromCharCode(code);
    });
};
export default function contents() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState.contents, action = arguments.length > 1 ? arguments[1] : void 0;
    var _state = _objectSpread({}, state);
    var cont = _objectSpread({}, action.content);
    switch(action.type){
        case FETCH_CONTENT_SUCCESS:
            if (typeof cont.cont === "string") {
                cont.cont = CharcodeEntitiesToChar(cont.cont);
            }
            _state[action.id] = cont;
            return _state;
        default:
            return state;
    }
}
